import type { SvgIconTypeMap } from '@mui/material';
import { SvgIcon } from '@mui/material';
import React from 'react';
type SVGProps = SvgIconTypeMap['props'] & React.SVGProps<SVGSVGElement>;
export function createSvgIcon(path: React.ReactNode, displayName: string, width = 24, height?: number) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const Component = (props: SVGProps, ref: any) => <SvgIcon data-testid={`${displayName}Icon`} ref={ref} style={{
    fill: 'none',
    ...props.style
  }} viewBox={`0 0 ${width} ${height ?? width}`} {...props}>
      {path}
    </SvgIcon>;
  if (process.env.NODE_ENV !== 'production') {
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = `${displayName}Icon`;
  }
  Component.muiName = SvgIcon.muiName;
  return React.memo(React.forwardRef(Component));
}